import { Directive, Input, OnDestroy, OnInit, TemplateRef, inject } from '@angular/core';
import { BoschUiTableService } from '../bosch-ui-table.service';
import { BehaviorSubject, filter, Observable, Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[boschUiRowDef]',
  standalone: false,
})
export class BoschUiRowDefDirective<DataType> implements OnInit, OnDestroy {
  public readonly templateRef = inject(TemplateRef<DataType>);
  private readonly tableService = inject(BoschUiTableService<DataType>);

  @Input() set boschUiRowDefColumns(boschUiRowDefColumns: string[]) {
    this.tableService.createRowCells(boschUiRowDefColumns);
    this._rowDisplayColumns = boschUiRowDefColumns;
  }

  get rowDisplayColumns(): string[] {
    return this._rowDisplayColumns;
  }

  private _rowDisplayColumns: string[] = [];
  private _rowIndex = 0;
  private _rowsData$ = new BehaviorSubject<DataType[]>([]);
  private _unsubscribe$ = new Subject<void>();

  public rowsData$: Observable<DataType[]> = this._rowsData$.asObservable();

  ngOnInit(): void {
    this.initTableDataChangesSubscription();
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
  }

  incrementRowIndex(): void {
    this._rowIndex += 1;
  }

  getRowIndex(): number {
    return this._rowIndex;
  }

  private initTableDataChangesSubscription(): void {
    this.tableService.data$.pipe(filter(Boolean), takeUntil(this._unsubscribe$)).subscribe((data: DataType[]) => {
      this._rowIndex = 0;
      this._rowsData$.next(data);
    });
  }
}
